import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { fmtDateTime, fmtINR } from "../lib/api";
import { StatusPill } from "../components/Primitives";

export default function JobCards() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    api.get("/job-cards", { params: { status: filter || undefined } }).then(({ data }) => setItems(data));
  }, [filter]);

  const statuses = ["", "draft", "pending_approval", "approved", "in_progress", "ready", "delivered"];

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div>
          <div className="kk-overline">04 · 02</div>
          <h2 className="font-display text-2xl uppercase">Job Cards</h2>
        </div>
      </div>
      <div className="flex gap-2 mb-4 flex-wrap">
        {statuses.map((s) => (
          <button
            key={s || "all"}
            onClick={() => setFilter(s)}
            className={"kk-pill " + (filter === s ? "kk-pill-black" : "kk-pill-muted")}
            data-testid={`jc-filter-${s || "all"}`}
          >
            {s ? s.replace(/_/g, " ") : "All"}
          </button>
        ))}
      </div>
      <div className="overflow-x-auto">
        <table className="kk-table">
          <thead>
            <tr>
              <th>Code</th>
              <th>Customer</th>
              <th>Vehicle</th>
              <th>Total</th>
              <th>Advance</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {items.map((j) => (
              <tr key={j.id} className="cursor-pointer" onClick={() => nav(`/service/jobcards/${j.id}`)} data-testid={`jc-row-${j.id}`}>
                <td className="font-mono">{j.code}</td>
                <td>{j.customer_name}<div className="text-xs text-[var(--kk-muted)]">{j.customer_phone}</div></td>
                <td>{j.make} {j.model}<div className="text-xs font-mono text-[var(--kk-muted)]">{j.registration_no}</div></td>
                <td className="font-mono">{fmtINR(j.totals?.grand_total || 0)}</td>
                <td className="font-mono">{fmtINR(j.advance_paid || 0)} / {fmtINR(j.advance_required || 0)}</td>
                <td><StatusPill status={j.status} /></td>
                <td className="font-mono text-xs">{fmtDateTime(j.created_at)}</td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={7} className="text-center text-[var(--kk-muted)] py-8">No job cards.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
